export default {
  mutations: {
    SET_ORDER_KINDS: 'SET_ORDER_KINDS',
  },
  getters: {
    GET_ORDER_KINDS: 'GET_ORDER_KINDS',
  },
  actions: {
    ORDER_KINDS: 'ORDER_KINDS_LIST',
  },
};
